var render = function render(){var _vm=this,_c=_vm._self._c;return _c('event-list',{attrs:{"extra":_vm.extra,"types":_vm.types,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }